/* Prime Outlet - Comparador de laptops, PCs de escritorio y All-in-One (metacampos specs.*) */
(function () {
  if (window.__poCompareLoaded) return;
  window.__poCompareLoaded = true;

  var KEY = 'po_compare_v1';
  var MAX = 4;
  var PAGE = '/pages/comparar';

  /* Tipos: laptop | pc | aio. Se pueden mezclar; al mezclar laptops con PCs/All-in-One se ocultan
     las filas propias de laptop y no se resalta "mejor valor" (son equipos para usos distintos). */
  var GRUPOS = {
    laptop: { nombre: 'laptops', titulo: 'Comparar laptops', ver: 'Ver laptops', url: '/collections/laptops-con-ia' },
    pc: { nombre: 'PCs y All-in-One', titulo: 'Comparar PCs y All-in-One', ver: 'Ver PCs de escritorio', url: '/collections/computadoras-de-sobremesa' }
  };
  function grupo(k) { return k === 'pc' || k === 'aio' ? 'pc' : 'laptop'; }
  function grupoLista(l) { return l.length ? grupo(l[0].k) : null; }

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function save(l) {
    try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
  }
  function has(l, h) { return l.some(function (x) { return x.h === h; }); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var list = load();

  /* ---------- Casillas "Comparar" (tarjetas y página de producto) ---------- */
  function syncToggles() {
    document.querySelectorAll('[data-po-compare]').forEach(function (el) {
      var on = has(list, el.getAttribute('data-handle'));
      var cb = el.querySelector('input');
      if (cb) cb.checked = on;
      el.classList.toggle('is-active', on);
      var lbl = el.querySelector('.po-cmp-label');
      var txt = on ? 'En comparación' : 'Comparar';
      if (lbl && lbl.textContent !== txt) lbl.textContent = txt;
    });
  }

  function itemDe(el) {
    return { h: el.getAttribute('data-handle'), t: el.getAttribute('data-title') || el.getAttribute('data-handle'), i: el.getAttribute('data-img') || '', k: el.getAttribute('data-tipo') || 'laptop' };
  }

  function toggle(el) {
    var it = itemDe(el);
    if (has(list, it.h)) {
      list = list.filter(function (x) { return x.h !== it.h; });
    } else {
      if (list.length >= MAX) {
        flash('Puedes comparar hasta ' + MAX + ' productos. Quita uno para agregar otro.');
        syncToggles();
        return;
      }
      list.push(it);
    }
    save(list);
    syncToggles();
    renderBar();
  }

  document.addEventListener('change', function (e) {
    var el = e.target.closest && e.target.closest('[data-po-compare]');
    if (el) { e.stopPropagation(); toggle(el); }
  });

  /* ---------- Barra flotante ---------- */
  var bar;
  function renderBar() {
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'po-cmp-bar';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Productos para comparar');
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-rm]');
        if (rm) {
          var h = rm.getAttribute('data-rm');
          list = list.filter(function (x) { return x.h !== h; });
          save(list); syncToggles(); renderBar();
          if (document.getElementById('po-compare-root')) renderPage();
        }
        if (e.target.closest('[data-clear]')) {
          list = []; save(list); syncToggles(); renderBar();
          if (document.getElementById('po-compare-root')) renderPage();
        }
      });
    }
    var onPage = !!document.getElementById('po-compare-root');
    if (!list.length || onPage) { bar.hidden = true; return; }
    bar.hidden = false;
    var items = list.map(function (x) {
      return '<div class="po-cmp-bar__item">' +
        (x.i ? '<img src="' + esc(x.i) + '" alt="" width="44" height="44" loading="lazy">' : '') +
        '<span class="po-cmp-bar__name">' + esc(x.t) + '</span>' +
        '<button type="button" class="po-cmp-bar__rm" data-rm="' + esc(x.h) + '" aria-label="Quitar ' + esc(x.t) + '">×</button></div>';
    }).join('');
    var href = PAGE + '?p=' + encodeURIComponent(list.map(function (x) { return x.h; }).join(','));
    bar.innerHTML =
      '<div class="po-cmp-bar__items">' + items + '</div>' +
      '<div class="po-cmp-bar__actions">' +
      '<button type="button" class="po-cmp-bar__clear" data-clear>Limpiar</button>' +
      (list.length >= 2
        ? '<a class="button po-cmp-bar__go" href="' + href + '">Comparar (' + list.length + ')</a>'
        : '<span class="po-cmp-bar__hint">Elige al menos 2 para comparar</span>') +
      '</div>';
  }

  var flashEl;
  function flash(msg, btn) {
    if (!flashEl) {
      flashEl = document.createElement('div'); flashEl.className = 'po-cmp-flash'; flashEl.setAttribute('role', 'status'); document.body.appendChild(flashEl);
      flashEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-flash-go]') && flashEl._accion) { flashEl._accion(); flashEl.classList.remove('is-on'); }
      });
    }
    flashEl._accion = btn ? btn.accion : null;
    flashEl.innerHTML = esc(msg) + (btn ? ' <button type="button" class="po-cmp-flash__go" data-flash-go>' + esc(btn.texto) + '</button>' : '');
    flashEl.classList.add('is-on');
    clearTimeout(flashEl._t);
    flashEl._t = setTimeout(function () { flashEl.classList.remove('is-on'); }, btn ? 7000 : 3500);
  }

  /* ---------- Página de comparación ---------- */
  function gb(n) {
    if (n == null || n === '') return '';
    n = Number(n);
    return n >= 1000 ? (Math.round(n / 100) / 10).toString().replace(/\.0$/, '') + ' TB' : n + ' GB';
  }
  function yes(v) { return v === true ? 'Sí' : v === false ? 'No' : ''; }
  function num(v, unit) { return v == null || v === '' ? '' : String(v).replace(/\.0+$/, '') + (unit || ''); }
  var TIPO_TXT = { laptop: 'Laptop', pc: 'PC de escritorio', aio: 'All-in-One' };

  var ROWS = [
    { group: 'General' },
    { label: 'Precio', get: function (p) { return p.price_fmt; }, val: function (p) { return p.price; }, best: 'min' },
    { label: 'Tipo de equipo', soloPc: true, get: function (p) { return p.tipo === 'aio' ? 'All-in-One' : p.tipo === 'laptop' ? 'Laptop' : (p.s.formato || TIPO_TXT[p.tipo] || ''); } },
    { label: 'Serie / modelo', get: function (p) { return p.s.serie; } },
    { label: 'Número de parte', get: function (p) { return p.s.numero_parte; } },
    { label: 'Sistema operativo', get: function (p) { return p.s.sistema_operativo; } },
    { group: 'Rendimiento' },
    { label: 'Procesador', get: function (p) { return p.s.procesador; } },
    { label: 'Núcleos / hilos', get: function (p) { return p.s.procesador_detalle; }, small: true },
    { label: 'Frecuencia máxima', get: function (p) { return num(p.s.procesador_ghz_max, ' GHz'); }, val: function (p) { return p.s.procesador_ghz_max; }, best: 'max' },
    { label: 'NPU (IA)', get: function (p) { return p.s.npu_tops ? p.s.npu_tops + ' TOPS' : (p.tipo !== 'laptop' && p.s.npu_tops == null ? '' : 'No tiene'); }, val: function (p) { return p.s.npu_tops; }, best: 'max' },
    { label: 'PC con IA', get: function (p) { return p.s.pc_con_ia; } },
    { label: 'Memoria RAM', get: function (p) { return p.s.ram_gb ? p.s.ram_gb + ' GB' + (p.s.ram_tipo ? ' ' + p.s.ram_tipo : '') : ''; }, val: function (p) { return p.s.ram_gb; }, best: 'max' },
    { label: 'RAM máxima', get: function (p) { return p.s.ram_max_gb ? p.s.ram_max_gb + ' GB' : ''; }, val: function (p) { return p.s.ram_max_gb; }, best: 'max' },
    { label: 'Almacenamiento', get: function (p) { return gb(p.s.almacenamiento_gb); }, val: function (p) { return p.s.almacenamiento_gb; }, best: 'max' },
    { label: 'Tipo de almacenamiento', get: function (p) { return p.s.almacenamiento_tipo; }, small: true },
    { label: 'Tarjeta gráfica', get: function (p) { return p.s.gpu; } },
    { label: 'Memoria de video', get: function (p) { if (p.tipo !== 'laptop' && p.s.gpu_dedicada == null) return ''; return p.s.gpu_dedicada ? (p.s.gpu_vram_gb ? p.s.gpu_vram_gb + ' GB (dedicada)' : 'Dedicada') : 'Compartida'; }, val: function (p) { return p.s.gpu_vram_gb; }, best: 'max' },
    { group: 'Pantalla' },
    { label: 'Tamaño', get: function (p) { if (p.tipo === 'pc' && p.s.pantalla_pulgadas == null) return 'Sin pantalla (monitor aparte)'; return num(p.s.pantalla_pulgadas, '"'); }, val: function (p) { return p.s.pantalla_pulgadas; }, best: 'maxPc' },
    { label: 'Resolución', get: function (p) { return p.s.pantalla_resolucion; } },
    { label: 'Panel', get: function (p) { return p.s.pantalla_panel; } },
    { label: 'Frecuencia', get: function (p) { return num(p.s.pantalla_hz, ' Hz'); }, val: function (p) { return p.s.pantalla_hz; }, best: 'max' },
    { label: 'Brillo', get: function (p) { return num(p.s.pantalla_nits, ' nits'); }, val: function (p) { return p.s.pantalla_nits; }, best: 'max' },
    { label: 'Táctil', get: function (p) { return yes(p.s.pantalla_tactil); } },
    { group: 'Diseño y batería', groupPc: 'Diseño' },
    { label: 'Batería', soloLaptop: true, get: function (p) { return num(p.s.bateria_wh, ' Wh'); }, val: function (p) { return p.s.bateria_wh; }, best: 'max' },
    { label: 'Peso', get: function (p) { return num(p.s.peso_kg, ' kg'); }, val: function (p) { return p.s.peso_kg; }, best: 'min' },
    { label: 'Teclado retroiluminado', soloLaptop: true, get: function (p) { return yes(p.s.teclado_retroiluminado); } },
    { label: 'Lector de huellas', soloLaptop: true, get: function (p) { return yes(p.s.lector_huella); } },
    { group: 'Conectividad' },
    { label: 'Inalámbrica', get: function (p) { return p.s.wifi; } },
    { label: 'Puertos', get: function (p) { return p.s.puertos; }, multi: true, small: true },
    { group: 'Documentos' },
    { label: 'Ficha técnica', html: function (p) { return p.s.ficha ? '<a href="' + esc(p.s.ficha) + '" target="_blank" rel="noopener">Descargar PDF</a>' : ''; } }
  ];

  function fetchProduct(h) {
    return fetch('/products/' + encodeURIComponent(h) + '?view=specs', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var p = JSON.parse(t); p.s = p.specs || {}; p.tipo = p.tipo || 'laptop'; return p; })
      .catch(function () { return null; });
  }

  /* Ajusta el título y el texto de la página según lo que se compara */
  function encabezado(ps, g, mixto) {
    var page = document.querySelector('.po-cmp-page');
    if (!page) return;
    var h1 = page.querySelector('h1');
    var intro = page.querySelector('.po-cmp-intro');
    var titulo, nombre;
    if (mixto) {
      var hay = {};
      ps.forEach(function (p) { hay[p.tipo] = true; });
      var partes = [];
      if (hay.laptop) partes.push('laptops');
      if (hay.pc) partes.push('PCs');
      if (hay.aio) partes.push('All-in-One');
      titulo = 'Comparar ' + (partes.length > 2 ? partes.slice(0, -1).join(', ') + ' y ' + partes[partes.length - 1] : partes.join(' y '));
      if (h1) h1.textContent = titulo;
      if (intro) intro.textContent = 'Compara hasta ' + MAX + ' equipos lado a lado. Como son equipos para usos distintos, mostramos los datos sin marcar un "mejor valor".';
      document.title = titulo + ' – Prime Outlet';
      return;
    }
    if (g === 'pc' && ps && ps.length) {
      var aio = ps.filter(function (p) { return p.tipo === 'aio'; }).length;
      if (aio === ps.length) { titulo = 'Comparar All-in-One'; nombre = 'All-in-One'; }
      else if (aio === 0) { titulo = 'Comparar PCs de escritorio'; nombre = 'PCs de escritorio'; }
      else { titulo = 'Comparar PCs y All-in-One'; nombre = 'equipos'; }
    } else if (g === 'laptop') { titulo = 'Comparar laptops'; nombre = 'laptops'; }
    else { titulo = 'Comparar equipos'; nombre = 'equipos'; }
    if (h1) h1.textContent = titulo;
    if (intro) intro.textContent = 'Compara hasta ' + MAX + ' ' + nombre + ' lado a lado. Resaltamos en verde el mejor valor de cada característica.';
    document.title = titulo + ' – Prime Outlet';
  }

  function vacio(root, msg) {
    var g = grupoLista(list);
    var links = g
      ? '<a class="button" href="' + GRUPOS[g].url + '">' + GRUPOS[g].ver + '</a>'
      : '<a class="button" href="' + GRUPOS.laptop.url + '">Ver laptops</a> <a class="button button--secondary" href="' + GRUPOS.pc.url + '">Ver PCs de escritorio</a> <a class="button button--secondary" href="/collections/all-in-one">Ver All-in-One</a>';
    root.innerHTML = '<div class="po-cmp-empty"><p>' + msg + '</p><div class="po-cmp-empty__links">' + links + '</div></div>';
  }

  function renderPage() {
    var root = document.getElementById('po-compare-root');
    if (!root) return;
    var q = new URLSearchParams(location.search).get('p');
    var handles = q ? q.split(',').filter(Boolean).slice(0, MAX) : list.map(function (x) { return x.h; });
    if (q && !handles.every(function (h) { return has(list, h); })) {
      // Si llegan desde un enlace compartido, sincroniza la lista local
      list = handles.map(function (h) { var f = list.find(function (x) { return x.h === h; }); return f || { h: h, t: h, i: '', k: '' }; });
      save(list);
    }
    if (handles.length < 2) {
      encabezado(null, grupoLista(list));
      vacio(root, 'Agrega al menos 2 productos con el botón <strong>Comparar</strong> que aparece en cada laptop, PC de escritorio o All-in-One.');
      return;
    }
    root.innerHTML = '<p class="po-cmp-loading">Cargando especificaciones…</p>';
    Promise.all(handles.map(fetchProduct)).then(function (ps) {
      ps = ps.filter(Boolean);
      list = ps.map(function (p) { return { h: p.handle, t: p.title, i: p.thumb || '', k: p.tipo }; });
      save(list); syncToggles();
      if (ps.length < 2) {
        encabezado(null, grupoLista(list));
        vacio(root, 'No se pudieron cargar al menos 2 productos para comparar.');
        return;
      }
      draw(root, ps);
    });
  }

  function draw(root, ps) {
    var g = grupo(ps[0].tipo);
    var mixto = ps.some(function (p) { return grupo(p.tipo) !== g; });
    if (mixto) g = 'mixto';
    encabezado(ps, g, mixto);
    var onlyDiff = root.getAttribute('data-only-diff') === '1';
    var head = '<tr><th class="po-cmp-corner" scope="col">' +
      '<label class="po-cmp-diff"><input type="checkbox" ' + (onlyDiff ? 'checked' : '') + ' data-diff> Solo diferencias</label></th>' +
      ps.map(function (p) {
        return '<th scope="col" class="po-cmp-prod">' +
          '<button type="button" class="po-cmp-x" data-rm="' + esc(p.handle) + '" aria-label="Quitar">×</button>' +
          '<a href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
          '<span class="po-cmp-title">' + esc(p.title) + '</span></a>' +
          '<span class="po-cmp-price">' + esc(p.price_fmt) + (p.compare && p.compare > p.price ? ' <s>' + esc(p.compare_fmt) + '</s>' : '') + '</span>' +
          (p.available ? '<a class="button po-cmp-buy" href="' + esc(p.url) + '">Ver producto</a>' : '<span class="po-cmp-soldout">Agotado</span>') +
          '</th>';
      }).join('') + '</tr>';

    var body = '';
    var pendingGroup = null;
    ROWS.forEach(function (r) {
      if (r.group) { pendingGroup = g !== 'laptop' && r.groupPc ? r.groupPc : r.group; return; }
      if (r.soloPc && g === 'laptop') return;
      if (r.soloLaptop && mixto) return;
      var cells = ps.map(function (p) { return r.html ? r.html(p) : esc(r.get(p) || ''); });
      if (cells.every(function (c) { return !c || c.indexOf('Sin pantalla') === 0; })) return;
      var same = cells.every(function (c) { return c === cells[0]; });
      if (onlyDiff && same && !r.html) return;
      var bestIdx = [];
      var best = mixto ? null : r.best === 'maxPc' ? (g === 'pc' ? 'max' : null) : r.best;
      if (best && !same) {
        var vals = ps.map(function (p) { var v = Number(r.val(p)); return isNaN(v) || r.val(p) == null ? null : v; });
        var valid = vals.filter(function (v) { return v != null; });
        if (valid.length > 1) {
          var target = best === 'max' ? Math.max.apply(null, valid) : Math.min.apply(null, valid);
          vals.forEach(function (v, i) { if (v === target) bestIdx.push(i); });
        }
      }
      if (pendingGroup) {
        body += '<tr class="po-cmp-group"><th colspan="' + (ps.length + 1) + '" scope="colgroup">' + pendingGroup + '</th></tr>';
        pendingGroup = null;
      }
      body += '<tr' + (same ? ' class="is-same"' : '') + '><th scope="row">' + r.label + '</th>' +
        cells.map(function (c, i) {
          var cls = [];
          if (bestIdx.indexOf(i) > -1) cls.push('is-best');
          if (r.small) cls.push('is-small');
          if (r.multi) c = c.replace(/\n/g, '<br>');
          return '<td' + (cls.length ? ' class="' + cls.join(' ') + '"' : '') + '>' + (c || '—') + '</td>';
        }).join('') + '</tr>';
    });

    root.innerHTML =
      (mixto ? '' : '<p class="po-cmp-legend"><span class="po-cmp-dot"></span> Mejor valor en esa característica</p>') +
      '<div class="po-cmp-scroll"><table class="po-cmp-table"><thead>' + head + '</thead><tbody>' + body + '</tbody></table></div>';

    root.querySelector('[data-diff]').addEventListener('change', function (e) {
      root.setAttribute('data-only-diff', e.target.checked ? '1' : '0');
      draw(root, ps);
    });
    root.querySelectorAll('.po-cmp-x').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = b.getAttribute('data-rm');
        list = list.filter(function (x) { return x.h !== h; });
        save(list); syncToggles();
        var rest = ps.filter(function (p) { return p.handle !== h; });
        history.replaceState(null, '', PAGE + '?p=' + encodeURIComponent(rest.map(function (p) { return p.handle; }).join(',')));
        if (rest.length < 2) renderPage(); else draw(root, rest);
      });
    });
  }

  /* ---------- Casilla en tarjetas de colección / búsqueda / inicio ---------- */
  var INDEX_URL = '/collections/comparador-laptops?view=po-cmp-index';
  var IDX_KEY = 'po_cmp_idx_v3';
  var idx = null;
  function getIndex() {
    try {
      var c = JSON.parse(sessionStorage.getItem(IDX_KEY) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000 && c.m) return Promise.resolve(c.m);
    } catch (e) {}
    return Promise.all([1, 2, 3].map(function (pg) { return fetch(INDEX_URL + '&page=' + pg, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : '{}'; }).catch(function () { return '{}'; }); }))
      .then(function (ts) { var all = {}; ts.forEach(function (t) { try { var v = JSON.parse(t); if (v && typeof v === 'object' && !Array.isArray(v)) for (var k in v) all[k] = v[k]; } catch (e) {} }); return JSON.stringify(all); })
      .then(function (t) {
        var m = {};
        try {
          var v = JSON.parse(t);
          if (Array.isArray(v)) v.forEach(function (h) { m[h] = 'laptop'; }); else if (v && typeof v === 'object') m = v;
        } catch (e) {}
        try { sessionStorage.setItem(IDX_KEY, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
        return m;
      })
      .catch(function () { return {}; });
  }
  function decorate() {
    if (!idx) return;
    document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
      if (card.querySelector('[data-po-compare]')) return;
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var h = decodeURIComponent(m[1]);
      if (!Object.prototype.hasOwnProperty.call(idx, h)) return;
      var titleEl = card.querySelector('.card__heading a') || a;
      var img = card.querySelector('.card__media img');
      var label = document.createElement('label');
      label.className = 'po-cmp-toggle';
      label.setAttribute('data-po-compare', '');
      label.setAttribute('data-handle', h);
      label.setAttribute('data-tipo', idx[h] || 'laptop');
      label.setAttribute('data-title', (titleEl.textContent || '').trim());
      label.setAttribute('data-img', img ? (img.getAttribute('src') || '') : '');
      label.innerHTML = '<input type="checkbox" aria-label="Comparar"><span class="po-cmp-label">Comparar</span>';
      var host = card.querySelector('.card-information') || card.querySelector('.card__information');
      if (host) host.appendChild(label);
    });
    syncToggles();
  }

  /* Completa el tipo de los productos guardados antes de esta versión (todos eran laptops) */
  list.forEach(function (x) { if (!x.k) x.k = 'laptop'; });

  function init() {
    getIndex().then(function (m) {
      idx = m;
      var cambio = false;
      list.forEach(function (x) { if (idx[x.h] && idx[x.h] !== x.k) { x.k = idx[x.h]; cambio = true; } });
      if (cambio) save(list);
      decorate();
    });
    syncToggles();
    renderBar();
    renderPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Re-sincroniza cuando la colección carga productos por AJAX (filtros/paginación)
  var moT;
  new MutationObserver(function () { clearTimeout(moT); moT = setTimeout(function () { decorate(); syncToggles(); }, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { list = load(); syncToggles(); renderBar(); } });
})();
